/**
 * 文件选择对话框组件
 * 从 MainPage.tsx 提取，用于减少主文件大小
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography
} from '@mui/material';

interface FileSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  selectedFileName: string | null;
  fileRelativePath: string;
  onSmartMatch: () => Promise<void>;
  onUploadToCloud: () => void;
}

const FileSelectionDialog: React.FC<FileSelectionDialogProps> = ({
  open,
  onClose,
  selectedFileName,
  fileRelativePath,
  onSmartMatch,
  onUploadToCloud
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onSmartMatch(); // Enter 鍵快速選擇預設選項
        }
      }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        📁 檔案選擇
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            已選擇檔案：<strong>{selectedFileName || fileRelativePath}</strong>
          </Typography>
          {fileRelativePath && selectedFileName !== fileRelativePath && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              請重新選擇檔案：{fileRelativePath}
            </Typography>
          )}
        </Box>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            onClick={onSmartMatch}
            autoFocus
            sx={{ 
              py: 2,
              fontSize: '1.1rem',
              backgroundColor: '#1976d2',
              color: 'white',
              height: 'auto',
              minHeight: '80px',
              '&:hover': {
                backgroundColor: '#1565c0'
              },
              '&:focus': {
                backgroundColor: '#1976d2',
                boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
              }
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                🎬 智能檔案匹配播放
              </Box>
              <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: 1.2 }}>
                自動匹配本地檔案，找不到時手動選擇
              </Typography>
            </Box>
          </Button>
          
          <Button
            variant="outlined"
            size="large"
            onClick={onUploadToCloud}
            sx={{ 
              py: 2,
              fontSize: '1.1rem',
              borderColor: '#2e7d32',
              color: '#2e7d32',
              height: 'auto',
              minHeight: '80px',
              '&:hover': {
                borderColor: '#1b5e20',
                backgroundColor: '#f1f8e9'
              }
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                ☁️ 將檔案上傳雲端
              </Box>
              <Typography variant="caption" sx={{ lineHeight: 1.2 }}>
                上傳到雲端並進入檔案總管
              </Typography>
            </Box>
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FileSelectionDialog;

